<template>
	<div id="modal-wrapper">
		<modal-component ref="modal" :anotherBackground="true" @onModalClose="this.$emit('onModalClose')">
			<div
        id="price-modal" 
        class="modal-container"
      >
				<div class="modal-header">
          Price
        </div>
				
				<div class="sets">
					<div class="inputs">						
						<div class="manual">
							<label for="mv">Price:</label>
							<div class="input_disc_group">
                <input
                  id="mv"
                  type="text"
                  v-model="manualValue"
                  @keypress="isNumber($event)"
                >

                {{ manualValueType === 1 ? '$' : '%' }}
              </div>
						</div>
					</div>
				</div>
				<keypad
					@clickOnKey="keypadClick"
					@clear="keypadClear"
				></keypad>

				<div class="modal-controls">
					<base-button
            text="CANCEL"
            classes="def-btn cancel-action-btn uppercase medium border-2" 
            @onClick="closeModal"
          />

          <base-button
            text="Confirm"
            classes="def-btn main-action-btn uppercase medium border-2"
            :class="{ 'disabled': isNaN(parseFloat(manualValue))}"
            @onClick="confirm"
          />
				</div>
			</div>
		</modal-component>
	</div>
</template>

<script>
import ModalComponent from "@/components/_shared/Modal";
import Keypad from "@/components/_shared/Keypad";
import BaseButton from "@/components/_shared/Button.vue";

export default {
	name: 'PriceModalComponent',

  emits: ['onModalClose'],

	components: {
    BaseButton,
    ModalComponent,
    Keypad,
  },

  data() {
		return {
			manualValue: '',

      manualValueType: 1,

      onConfirm: () => {},
		}
	},
	computed: {
		design() {
			return this.$store.state.UI;
		},
	},

	beforeUnmount() {
		this.emmiter.emit('toggleModals', {opened: false, type: 'PriceModal'});
	},

	methods: {
		confirm() {
      if (isNaN(parseFloat(this.manualValue))) {
        return;
      }

      this.onConfirm(this.manualValue);

      this.$refs['modal'].close();
		},

		isNumber(e) {
			e = (e) ? e : window.event;
			let charCode = (e.which) ? e.which : e.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
				e.preventDefault();
			} else {
				return true;
			}
		},
	
		openModal(options) {
			this.$refs['modal'].show();

      if (options?.item?.open_price_value) {
        this.manualValue = options?.item?.open_price_value;
      }

      if (options?.item?.open_price_type) {
        this.manualValueType = options.item.open_price_type;
      }

      this.onConfirm = options.onConfirm;

			this.emmiter.emit('toggleModals', {opened: true, type: 'PriceModal'});
		},

    closeModal() {
			this.emmiter.emit('toggleModals', {opened: false, type: 'PriceModal'});
			this.$refs['modal'].close();
		},

    keypadClick(e) {
				this.manualValue += e.toString();
		},

		keypadClear() {
      this.manualValue = this.manualValue.slice(0, -1)
		},
	},
}
</script>

<style lang="less" scoped>
#modal-wrapper {
	.window {
		background-color: #F5F9FC !important;
	}
	
	#price-modal {
		width: 600px;
		background-color: #F5F9FC;
		
		.modal-header {
			font-style: normal;
			font-weight: 300;
			font-size: 42px;
			line-height: 56px;
			text-align: center;
			color: #3F8EC5;
		}
		
		.sets {
			width: 100%;
			display: flex;
			flex-direction: row;
			gap: 18px;
			margin-bottom: 26px;
			
			.inputs {
				flex: 4;
				flex-direction: column;
				
				.fidelio {
					padding: 3px;
					width: 100%;
					height: 40px;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					background-color: #fff;
					margin-bottom: 24px;
					
					p {
						padding: 0;
						width: max-content;
						font-style: normal;
						font-weight: 600;
						font-size: 14px;
						line-height: 16px;
						color: #1C282D;
					}
				}
				
				.manual {
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					gap: 4px;
					
					label {
						padding: 0;
						width: max-content;
						font-style: normal;
						font-weight: 600;
						font-size: 14px;
						line-height: 16px;
						color: #1C282D;
					}
					
					.input_disc_group {
						width: 100%;
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: space-between;
						gap: 8px;

						input {
							box-sizing: border-box;
							padding: 3px;
							width: 100%;
							height: 40px;
							background-color: #fff;
							border: none;
							border-bottom: 2px solid #3F8EC5;
							font-style: normal;
							font-weight: 400;
							font-size: 18px;
							line-height: 20px;
							color: #1C282D;
						}
					}
				}
			}
			
			.switches {
				padding: 4px 0;
				width: max-content;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
			}
		}
		
		.discounts-table {
			width: 100%;
			padding: 0;
			box-sizing: border-box;
			max-height: 400px;
			overflow-x: auto;
			
			.table {
				width: 100%;
				table-layout: fixed;
				border-collapse: collapse;
				box-sizing: border-box;
				text-align: left;
				background-color: #fff;
				
				thead {
					font-style: normal;
					font-weight: 600;
					font-size: 12px;
					color: #1C282D;
					
					tr {
						height: 36px;
						
						th {
							border: 1px solid #E5E0EB;
							border-top: 2px solid #E5E0EB;
							border-bottom: 2px solid #E5E0EB;
							padding: 2px;
							text-align: center;
						}
						
						.th-name {
							width: 30%;
							border-left: none;
						}
						
						.th-price {
							width: 15%;
						}
						
						.th-q {
							width: 15%;
						}
						
						.th-fd {
							width: 15%;
						}
						
						.th-md {
							width: 40%;
							border-right: none;
						}
					}
					
				}
				
				tbody {
					font-style: normal;
					font-weight: 400;
					font-size: 14px;
					color: #1C282D;
					
					tr {
						height: 36px;
						
						td {
							padding: 2px;
							border: 1px solid #E5E0EB;
							text-align: right;
						}
						
						.td-name {
							border-left: none;
							text-align: left;
						}
						
						.td-md {
							padding: 2px 6px;
							border-right: none;
							
							.md_box {
								width: 100%;
								display: flex;
								flex-direction: row;
								justify-content: space-between;
								&__ti {
									padding: 0 4px;
									width: 138px;
									border: none;
									background-color: #ECF4F9;
									line-height: 24px;
								}
								&__sw {
									// width: 44px;
									
								}
							}
						}
					}
				}
			}
			
			// .total {
			// 	text-align: right;
			// 	font-weight: bold;
			// 	text-transform: uppercase;
			// 	span {
			// 		margin-left: 20px;
			// 	}
			// }
		}
		
		.keypad {
			margin: 0 auto;
			border: none;
			margin-bottom: 24px;
		}
		
		.modal-controls {
			justify-content: center;
			gap: 12px;
			
			button {
				width: 180px;
				height: 48px;
				font-style: normal;
				font-weight: 600;
				font-size: 16px;
			}
		}
	}
	
	.switch {
		&_1 {
			--toggle-text-off: #EB262B;
		}
		&_2 {
			--toggle-font-size: 1.5rem;
		}
	}
}
</style>
